import Vue from 'vue'
import Component from 'vue-class-component'
import { judgeDeviceType } from "@/utils/device"

@Component({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    textLength: {
      type: Number,
      default: 0
    },
    videoStyle: {
      type: String,
      default: ''
    },
    speakerName: {
      type: String,
      default: ''
    },
    speakerStyle: {
      type: String,
      default: '默认'
    },
    speakerSpeed: {
      type: String,
      default: '1.0'
    },
    leftCount: {
      type: Number,
      default: 0
    },
    totalCount: {
      type: Number,
      default: 0
    },
    // 判断会员
    isVip: {
      type: Boolean,
      default: false
    },
    // 扣减次数
    deductions: {
      type: Number,
      default: 0
    }
  },
  watch: {
    'visible': {
      handler(state) {
        this.isVisible = state
      }
    }
  }
})
export default class VideoContentPopup extends Vue {
  // 判断是/否是 app 页面
  isApp = judgeDeviceType.isAPP

  isVisible = false

  /** 关闭弹窗 */
  handleHidePopup() {
    this.$emit('close')
  }
  /** 确认生成视频 */
  confirmGenerateVideo() {
    if (!this.$props.leftCount || (this.$props.deductions > this.$props.leftCount)) {
      return
    }
    this.$emit('confirm')
  }
  /** 跳转到购买会员页面 */
  toVipPage() {
    this.$navigateTo({
      url: '/mine-package/pages/recharge-vip/recharge-vip'
    })
  }
  toPackagePage() {
    this.$navigateTo({
      url: '/mine-package/pages/recharge-vip/recharge-vip?target=EXPOSE_VIDEO'
    })
  }
}
